import { DataPacket_Kind, ParticipantEvent, RemoteParticipant, RemoteTrackPublication, Track } from 'livekit-client'
import React, { useEffect, useState, memo, useCallback, useRef } from 'react'
import RemoteVideo from '../RemoteVideo/RemoteVideo';
import ParticipantInfo from '../ParticipentInfo/ParticipentInfo'
import { useDispatch, useSelector } from "react-redux";
import { restoreCameraTrack, setStopedCameraTracks } from '../../../store/livekitSlice/livekitSlice';
import { mapSocketFactory } from '../../../../../utils/socketFactory';
import { useTranslation } from 'react-i18next';
import { EXCLUDE_USER } from '../../../../Map/store/Avatars/AvatarsSlice';
import { virerUser } from '../../../../Map/store/MapDisplayThunks';
import ActionConfirmation from '../../../../../components/ActionConfirmation';
import { addActiveGame, setIncomingInvite } from '../../../../Games/store/GamesSlice';
import { tr } from 'date-fns/locale';
/**
 * Renders a single remote participant's video and audio tracks.
 * @param {RemoteParticipant} remoteParticipant - A LiveKit RemoteParticipant object.
 * @returns {JSX.Element} A JSX element with a video and audio tracks.
 */
//Memorizing component to prevernt unnecessary re-renders
const RemoteParticipantPlayer = memo(({ remoteParticipant, onRemoteScreenShare, handRank, room ,
  forcedName
 }) => {
  const [remoteVideoTrack, setRemoteVideoTrack] = useState(null);
  const [remoteScreenShareTrack, setRemoteScreenShareTrack] = useState(null);
  const [remoteAudioTrack, setRemoteAudioTrack] = useState(null);
  const { zoomedTrackId, conferenceMode, stopedCameraTracks } = useSelector(state => state.livekit);
  const [confirmDialogMiCOpen, setconfirmDialogMicOpen] = useState(false);
  const { localAvatar } = useSelector((state) => state.auth);
  const [ConfirmFireUserDialogOpen, setConfirmFireUserDialogOpen] = useState(false);
  const { currentRoom } = useSelector((state) => state.MapDisplay);
  const dispatch = useDispatch();
  const setZoomedTrackSid = () => { }
  const [cameraDisabledLocal, setCameraDisabledLocal] = useState(
    remoteVideoTrack
      ? Object.values(stopedCameraTracks).includes(remoteVideoTrack.sid)
      : false
  );
  const { incomingInvite } = useSelector(state => state.games);
  const { t } = useTranslation();

  const remoteScreenShareTrackRef = useRef(remoteScreenShareTrack);
  useEffect(() => {
    remoteScreenShareTrackRef.current = remoteScreenShareTrack;
  }, [remoteScreenShareTrack]);

  // Dans RemoteParticipantPlayer.jsx
  useEffect(() => {
    const email = remoteParticipant.participantInfo?.identity;
    const isStoppedLocally = email && !!stopedCameraTracks[email];
    console.log(`[${email}] isStoppedLocally:`, isStoppedLocally);
    setCameraDisabledLocal(isStoppedLocally);

  }, [stopedCameraTracks, remoteParticipant.participantInfo?.identity]);
  useEffect(() => {
    if (Object.keys(stopedCameraTracks).length > 0) {
      Object.entries(stopedCameraTracks).forEach(([email, trackSid]) => {
        if (trackSid) {
          console.log(`Restoring camera for ${email}, trackSid: ${trackSid}`);
          dispatch(restoreCameraTrack(email));
        } else {
          console.log(`No stopped track found for ${email}`);
        }
      });
      dispatch(setStopedCameraTracks({}));
      console.log("Toutes les caméras restaurées et stopedCameraTracks vidés");
    }

  }, [currentRoom]);



  const handleStopCamera = () => {
    dispatch(setStopedCameraTracks({
      email: remoteParticipant.participantInfo?.identity,
      trackSid: remoteVideoTrack.sid
    }));
  };

  const handleRestoreCamera = () => {
    const email = remoteParticipant.participantInfo?.identity;
    if (!email) return;

    const trackSid = stopedCameraTracks[email]; // clé = email, valeur = trackSid

    if (trackSid) {
      console.log(`Restoring camera for ${email}, trackSid: ${trackSid}`);
      dispatch(restoreCameraTrack(email));
    } else {
      console.log(`No stopped track found for ${email}`);
    }
  };


  const handleCloseMicClick = useCallback((event) => {
    event.stopPropagation();
    setconfirmDialogMicOpen(true);
  }, []);
  const handleConfirmCloseMic = () => {

    if (mapSocketFactory && mapSocketFactory.socket && remoteParticipant.participantInfo?.identity) {
      if (!mapSocketFactory.socket.connected) {
        console.error("⛔ ÉCHEC ÉMISSION: La socket est déconnectée ou en reconnexion.", {
          id: mapSocketFactory.socket.id,
          ready_state: mapSocketFactory.socket.readyState // Pour info
        });
        setconfirmDialogMicOpen(false);
        return;
      }
      mapSocketFactory.socket.emit('setMicState', {
        email: remoteParticipant.participantInfo?.identity,
        mic_state: 0,
        sender: localAvatar?.display_name

      });
      console.log(`[Socket] setMicState émis via mapSocketFactory pour: ${remoteParticipant.participantInfo.email}`);
    } else {
      console.error("⛔ ÉCHEC ÉMISSION: La socket n'est pas disponible.");
    }
    setconfirmDialogMicOpen(false);



  };

  const handleInviteToGame = (gameType) => {
    if (!room) {
      console.error("Erreur : room non reçu via les props");
      return;
    }
    const encoder = new TextEncoder();
    const data = encoder.encode(JSON.stringify({
      type: 'GAME_INVITE',
      game: gameType,
      fromName: localAvatar?.display_name
    }));

    // On publie la donnée uniquement vers ce participant spécifique
    room.localParticipant.publishData(data, {
      reliability: DataPacket_Kind.RELIABLE,
      destinationIdentities: [remoteParticipant.participantInfo?.identity]
    });

  };
  const handleDeclineInvite = async () => {
    if (!room || !incomingInvite) return;

    const encoder = new TextEncoder();
    const data = encoder.encode(JSON.stringify({
      type: 'GAME_DECLINED',
      fromName: localAvatar?.display_name || "L'utilisateur",
      game: incomingInvite.game
    }));

    try {
      // Envoi CIBLÉ uniquement à celui qui a invité
      await room.localParticipant.publishData(data, {
        reliability: DataPacket_Kind.RELIABLE,
        destinationIdentities: [incomingInvite.senderIdentity] // <--- Cible précis
      });
    } catch (error) {
      console.error("Erreur lors de l'envoi du refus", error);
    }

    // Fermer la modale
    dispatch(setIncomingInvite(null));
  };

  const handleAcceptInvite = async () => {
    if (!room || !incomingInvite) return;

    const encoder = new TextEncoder();
    const newGameId = `game_${Date.now()}_${incomingInvite.senderIdentity}`;

    const gamePayload = {
      type: 'GAME_ACCEPTED',
      gameId: newGameId,
      game: incomingInvite.game,
      player1: incomingInvite.senderIdentity, // L'inviteur
      player2: room.localParticipant.identity,     // Moi
      player1Name: incomingInvite.fromName,
      player2Name: localAvatar?.display_name
    };

    const data = encoder.encode(JSON.stringify(gamePayload));

    try {
      await room.localParticipant.publishData(data, {
        reliability: DataPacket_Kind.RELIABLE,
        destinationIdentities: []
      });
      console.log("Acceptation diffusée à toute la room");

      dispatch(addActiveGame({
        type: gamePayload.game,
        gameId: gamePayload.gameId,
        player1Id: gamePayload.player1,
        player2Id: gamePayload.player2,
        player1Name: gamePayload.player1Name,
        player2Name: gamePayload.player2Name,
        isSpectator: false,
        roomId: room.name
      }));

    } catch (error) {
      console.error("Erreur lors de l'acceptation", error);
    }

    // Fermer la modale d'invitation
    dispatch(setIncomingInvite(null));
  };


  useEffect(() => {
    /** 
    * @param {Track} track - A LiveKit Track object.
    */
    const onTrackSubscribed = (track) => {
      try {
        switch (track.source) {
          case Track.Source.Camera:
            setRemoteVideoTrack(track);
            break;
          case Track.Source.ScreenShare:
            // Only set the screen share callback if it's different from the current one
            if (remoteScreenShareTrackRef.current && remoteScreenShareTrackRef.current?.sid === track.sid) {
              return
            }
            setRemoteScreenShareTrack((prevTrack) => {
              if (prevTrack && prevTrack.sid === track.sid) {
                return prevTrack;
              }
              onRemoteScreenShare();
              return track;

            }
            );
            break;
          case Track.Source.Microphone:
            setRemoteAudioTrack(track);
            break;
          default:
            break;
        }

      }
      catch (error) {
        console.error("Error processing subscribed track", error);
      }

    }

    /** 
    *@param {Track} track - A LiveKit Track object. 
    */
    const onTrackUnsubscribed = (track) => {
      try {
        switch (track.source) {
          case Track.Source.Camera:
            const email = remoteParticipant.participantInfo?.identity;
            console.log(`[${email}] Camera unsubscribed`);
            if (email && stopedCameraTracks[email]) {
              console.log(`[${email}] Camera unsubscribed, removing local stop state.`);
              dispatch(restoreCameraTrack(email));
            }
            setRemoteVideoTrack(null);
            break;
          case Track.Source.ScreenShare:
            setRemoteScreenShareTrack(null);
          case Track.Source.Microphone:
            setRemoteAudioTrack(null);
            break;
          default:
            console.warn("Unknown track source:", track.source);
            break;
        }

      }
      catch (error) {
        console.error("Error processing unsubscribed track", error);
      }

    }

    remoteParticipant.on(ParticipantEvent.TrackSubscribed, onTrackSubscribed);
    remoteParticipant.on(ParticipantEvent.TrackUnsubscribed, onTrackUnsubscribed);

    // Redudancy interval in case events are missed
    const redundancyInterval = setInterval(() => {
      remoteParticipant.trackPublications.forEach((trackPublication) => {
        if (trackPublication.subscribed) {
          onTrackSubscribed(trackPublication.track);
        } else {
          onTrackUnsubscribed(trackPublication.track);
        }
      });
    }, 5000); // every 5 seconds

    // Get existing subscribed tracks right after attaching listners
    try {
      remoteParticipant?.trackPublications.forEach((trackPublication, sid) => {
        if (trackPublication.subscriptionStatus === RemoteTrackPublication.SubscriptionStatus.Subscribed)
          onTrackSubscribed(trackPublication.track)
        else
          console.log("not subscribed to track:", trackPublication.track, "please handle this.")
      }
      );
    }
    catch (error) {
      console.error("Error getting initial subscribed tracks", error);
    }

    return () => {
      setRemoteVideoTrack(null);
      setRemoteScreenShareTrack(null);
      setRemoteAudioTrack(null);
      remoteParticipant.off(ParticipantEvent.TrackSubscribed, onTrackSubscribed);
      remoteParticipant.off(ParticipantEvent.TrackUnsubscribed, onTrackUnsubscribed);

      clearInterval(redundancyInterval);
    }

  }, [remoteParticipant])


  const handleFireUserClick = useCallback((event) => {
    event.stopPropagation();
    console.log("handleFireUserClick");
    setConfirmFireUserDialogOpen(true);
  }, []);

  const handleConfirmFireUser = useCallback(async () => {
    const email = remoteParticipant.participantInfo?.identity;
    if (email) {
      const res = await dispatch(virerUser({ params: [{ email: email }] }));
      console.log("retour virerUser ", res);
      const res2 = dispatch(EXCLUDE_USER({ email: email, sender: localAvatar?.display_name }));
      console.log("retour socket ", res2);
    }
    setConfirmFireUserDialogOpen(false);
  }, [remoteParticipant]);

  return (
    <>
      {remoteVideoTrack && (
        <RemoteVideo key={remoteVideoTrack.Sid} type="remoteVideo" remoteVideoTrack={remoteVideoTrack} participantInfo={remoteParticipant.participantInfo} participantAudioTrack={remoteAudioTrack} handRank={handRank} handleStopCamera={handleStopCamera} cameraDisabledLocal={cameraDisabledLocal} handleInviteToGame={handleInviteToGame}
          handleCloseMicClick={handleCloseMicClick}
          handleConfirmCloseMic={handleConfirmCloseMic}
          confirmDialogMiCOpen={confirmDialogMiCOpen}
          setconfirmDialogMicOpen={setconfirmDialogMicOpen}
          handleFireUserClick={handleFireUserClick}
          handleConfirmFireUser={handleConfirmFireUser}
          setConfirmFireUserDialogOpen={setConfirmFireUserDialogOpen}
          ConfirmFireUserDialogOpen={ConfirmFireUserDialogOpen}
           forcedName ={forcedName}
        />
      )}

      {remoteScreenShareTrack && (
        <RemoteVideo key={remoteScreenShareTrack.Sid} type="remoteScreenShare" remoteVideoTrack={remoteScreenShareTrack} participantInfo={remoteParticipant.participantInfo} participantAudioTrack={remoteAudioTrack}
          handleCloseMicClick={handleCloseMicClick}
          autoZoom={true}
          handleConfirmCloseMic={handleConfirmCloseMic}
          confirmDialogMiCOpen={confirmDialogMiCOpen}
          setconfirmDialogMicOpen={setconfirmDialogMicOpen}
          handleFireUserClick={handleFireUserClick}
          handleConfirmFireUser={handleConfirmFireUser}
          setConfirmFireUserDialogOpen={setConfirmFireUserDialogOpen}
          ConfirmFireUserDialogOpen={ConfirmFireUserDialogOpen}
                    forcedName ={forcedName}

        />
      )}

      {!remoteVideoTrack &&
        <ParticipantInfo participant={remoteParticipant} participantAudioTrack={remoteAudioTrack} handRank={handRank} handleRestoreCamera={handleRestoreCamera} cameraDisabledLocal={cameraDisabledLocal} handleInviteToGame={handleInviteToGame}
          handleCloseMicClick={handleCloseMicClick}
          handleConfirmCloseMic={handleConfirmCloseMic}
          confirmDialogMiCOpen={confirmDialogMiCOpen}
          setconfirmDialogMicOpen={setconfirmDialogMicOpen}
          handleFireUserClick={handleFireUserClick}
          handleConfirmFireUser={handleConfirmFireUser}
          setConfirmFireUserDialogOpen={setConfirmFireUserDialogOpen}
          ConfirmFireUserDialogOpen={ConfirmFireUserDialogOpen}
        />
      }
      {incomingInvite && (
        <ActionConfirmation
          open={incomingInvite} // Toujours vrai si incomingInvite existe
          onClose={handleDeclineInvite}
          onConfirm={handleAcceptInvite}
          title={t("invite_game")} // "Invitation à jouer !"
          msg={t("invite_game_message", {
            user: incomingInvite.fromName,
            game: incomingInvite.game
          })}
          variant="primary" // ou "default", pas "destructive"
          cancelText={t("refuse")}
          confirmText={t("accept")}
        />
      )}
    </>
  )
});

export default RemoteParticipantPlayer;
